import { DEFAULT_JOB_OWNER, type IntegrationRun } from "../../shared/types";
import { mockRuns } from "../mocks/runs";
import { getWithFallback } from "./apiClient";

interface RunQuery {
  dateStart?: string;
  dateEnd?: string;
}

function toQueryString(query?: RunQuery): string {
  if (!query) {
    return "";
  }

  const params = new URLSearchParams();
  if (query.dateStart) {
    params.set("dateStart", query.dateStart);
  }
  if (query.dateEnd) {
    params.set("dateEnd", query.dateEnd);
  }

  const value = params.toString();
  return value ? `?${value}` : "";
}

function filterMockRuns(query?: RunQuery): IntegrationRun[] {
  if (!query) {
    return mockRuns;
  }

  return mockRuns.filter((run) => {
    const matchesDateStart = !query.dateStart || run.expectedStartTime >= `${query.dateStart}T00:00:00Z`;
    const matchesDateEnd = !query.dateEnd || run.expectedStartTime <= `${query.dateEnd}T23:59:59Z`;
    return matchesDateStart && matchesDateEnd;
  });
}

export function getRuns(query?: RunQuery): Promise<IntegrationRun[]> {
  return getWithFallback(`/runs${toQueryString(query)}`, () => filterMockRuns(query))
    .then((runs) => runs.map(withDefaultRunOwner));
}

export function getRunsForJob(jobId: string): Promise<IntegrationRun[]> {
  return getWithFallback(`/jobs/${jobId}/runs`, () => mockRuns.filter((run) => run.jobId === jobId))
    .then((runs) => runs.map(withDefaultRunOwner));
}

function withDefaultRunOwner(run: IntegrationRun): IntegrationRun {
  return {
    ...run,
    owner: DEFAULT_JOB_OWNER
  };
}
